import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

/**
 * Components
 */
import CircleCheck from '@pedidosya/web-fenix/icons/CircleCheck';
import Typography from '@pedidosya/web-fenix/foundations/Typography';
import circle from '@/src/assets/icons/circle_gray_filled.svg';

const RuleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space('spacing-component-medium')};
  margin-left: ${({ theme }) => theme.space('spacing-component-xlarge')};
`;

const RuleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space('spacing-component-medium')};
`;

const Image = styled.img`
  display: ${({ show }) => (show ? 'block' : 'none')};
`;

const PasswordRulesList = ({ rules, showSuccessMessage, successMessage }) => {
  const hasUncheckedRules = rules.some((rule) => rule.checked === false);

  return (
    <>
      <RuleList>
        {(hasUncheckedRules || !showSuccessMessage) &&
          rules.map((rule) => (
            <RuleItem key={rule.order}>
              {rule.checked && (
                <CircleCheck
                  size="small"
                  color="icon-color-action-validated-default"
                  filled
                />
              )}
              <Image src={circle.src} show={!rule.checked} />
              <Typography
                token="font-body-midcontrast-sentence-small"
                color={rule.checked ? 'feedback-positive' : 'action-inactive'}
              >
                {rule.message}
              </Typography>
            </RuleItem>
          ))}
      </RuleList>
      {rules.length > 0 && !hasUncheckedRules && showSuccessMessage && (
        <Typography
          token="font-body-midcontrast-sentence-small"
          color="feedback-positive"
          style={{ marginLeft: '8px' }}
        >
          {successMessage}
        </Typography>
      )}
    </>
  );
};

PasswordRulesList.propTypes = {
  rules: PropTypes.array,
  showSuccessMessage: PropTypes.bool,
  successMessage: PropTypes.string,
};

export default PasswordRulesList;
